import { createSlice } from "@reduxjs/toolkit";
import userStore from "../../../zustand/userStore";

const storedUser = localStorage.getItem("userData");
const initialState = {
  userData: storedUser ? JSON.parse(storedUser) : null,
  isAuthenticated: !!storedUser,
};

const studentQuizSlice = createSlice({
  name: "studentQuiz",
  initialState,
  reducers: {
    setQuizUser: (state, action) => {
      const data = action.payload;
      console.log("data", data);
      state.userData = data.user;
      state.isAuthenticated = true;
      userStore.setState({ user: data.user });
      localStorage.setItem("userData", JSON.stringify(data.user));
      localStorage.setItem("mdm_org_user", JSON.stringify(data.user));
      localStorage.setItem("token", data.token);
    },
    logoutQuizUser: (state) => {
      state.userData = null;
      state.isAuthenticated = false;
      localStorage.removeItem("userData");
      localStorage.removeItem("token");
      localStorage.removeItem("mdm_org_user");
      userStore.setState({ user: null });
    },
  },
});

export const { setQuizUser, logoutQuizUser } = studentQuizSlice.actions;
export default studentQuizSlice.reducer;
